import { render, staticRenderFns } from "./AddCameraForClassDialog.vue?vue&type=template&id=fbd6513c&scoped=true"
import script from "./AddCameraForClassDialog.vue?vue&type=script&lang=js"
export * from "./AddCameraForClassDialog.vue?vue&type=script&lang=js"
import style0 from "./AddCameraForClassDialog.vue?vue&type=style&index=0&id=fbd6513c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd6513c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbd6513c')) {
      api.createRecord('fbd6513c', component.options)
    } else {
      api.reload('fbd6513c', component.options)
    }
    module.hot.accept("./AddCameraForClassDialog.vue?vue&type=template&id=fbd6513c&scoped=true", function () {
      api.rerender('fbd6513c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/camera/AddCameraForClassDialog.vue"
export default component.exports